import classNames from "classnames";
import styles from "./Layout.module.scss"
import React, { useLayoutEffect, useRef } from "react";

const FixedPanel = React.memo(React.forwardRef(({ children, className, style }, forwardRef) => {
    const localRef = useRef();
    const ref = forwardRef || localRef;
    useLayoutEffect(() => {
        const { top } = ref.current.parentNode.getBoundingClientRect();
        ref.current.style.top = `${top}px`;
    }, []);

    return <div ref={ref} className={classNames(styles['fixed-panel'], className)} style={style}>
        {children}
    </div>
}))

export default FixedPanel;